import React from 'react';

import AnalyticsCarriers from 'app/collections/analytics_carriers';
import TrackingStatusReports from 'app/collections/tracking_status_reports';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';
import DropdownSelection from 'app/models/dropdown_selection';
import DropdownSelectionFromRemote from 'app/models/dropdown_selection_from_remote';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import SelectorView from 'app/views/selector_view';

import { List as ListView, Heading } from 'app/components/list/list';
import PageHeader from 'app/components/page_header_react';

import countAndPercentHeadingTemplate from './count_and_percent_heading';
import tmpl from './template';

export const CountAndPercentHeading = Base.extend({
  compiledTemplate: countAndPercentHeadingTemplate,

  context() {
    return {
      count: Number(this.model.get('total')).toLocaleString(),
      percent: this.model.get('percent'),
    };
  },
});

export const buildHeadings = () => [
  new Heading({
    property: 'categoryReadable',
    display: 'Status Category',
    xsSize: 6,
    smSize: 6,
  }),
  new Heading({
    subView: m => new CountAndPercentHeading({ model: m }),
    display: 'Count',
    wrapperClass: 'text-right',
    xsSize: 6,
    smSize: 6,
  }),
];

export const buildSubItems = () => ({
  property: 'statuses',
  headings: [
    new Heading({
      text: m => m.get('readable'),
      xsSize: 6,
      smSize: 6,
    }),
    new Heading({
      text: m => m.get('count'),
      wrapperClass: 'text-right',
      xsSize: 6,
      smSize: 6,
    }),
  ],
});

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'tracking-status-report',

  initialize() {
    // TODO: update this view and the correlated collection to use the dropdownSelections collection
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATE });

    this.carrierSelection = new DropdownSelectionFromRemote({
      staticChoices: [{ option: '', readable: 'All Carriers' }],
      label: 'Carrier',
      paramKey: 'carrier',
      remoteCollection: new AnalyticsCarriers([]),
    });

    this.servicePrioritySelection = new DropdownSelection({
      choices: [
        { option: '', readable: 'All Service Levels' },
        { option: 'standard', readable: 'Standard' },
        { option: 'express', readable: 'Express' },
      ],
      label: 'Service Priority',
      paramKey: 'service_priority',
    });

    this.collection = new TrackingStatusReports([], {
      dateRange: this.dateRange,
      carrierSelection: this.carrierSelection,
      servicePrioritySelection: this.servicePrioritySelection,
    });

    this.addReactComponent('header', <PageHeader name="Tracking Status Report" />);
    this.addSubview('carrierPicker', '#carrier_picker', new SelectorView({
      model: this.carrierSelection,
    }));
    this.addSubview('servicePriorityPicker', '#service_priority_picker', new SelectorView({
      model: this.servicePrioritySelection,
    }));
    this.addSubview('datepickers', '#daterange_pickers', new DatepickerRangeView({
      model: this.dateRange,
    }));
    this.addSubview('trackingStatusReportList', '#tracking_status_report_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      noResultsMessage: 'No results.',
      subItems: buildSubItems(),
      columnClasses: 'col-lg-5 col-md-8',
    }));

    this.collection.fetch();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/tracking_status_report/index.jsx